/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Contact_BodyInputs */

const en_faq_contact_body = /** @type {(inputs: Faq_Contact_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what you’re considering. We’ll talk it through with you.`)
};

const lv_faq_contact_body = /** @type {(inputs: Faq_Contact_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastāstiet, ko apsverat. Mēs to ar Jums pārrunāsim.`)
};

/**
* | output |
* | --- |
* | "Tell us what you’re considering. We’ll talk it through with you." |
*
* @param {Faq_Contact_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_contact_body = /** @type {((inputs?: Faq_Contact_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Contact_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_contact_body(inputs)
	return en_faq_contact_body(inputs)
});